export default "__VITE_ASSET__CR5z5r9F__"